// Class: starling.filters.GlowFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function starling_filters_BlurFilter() {return require("./../../starling/filters/BlurFilter");}
function starling_filters_CompositeFilter() {return require("./../../starling/filters/CompositeFilter");}

// Constructor

var GlowFilter = function(color,alpha,blur,quality) {
	if(quality == null) {
		quality = 0.5;
	}
	if(blur == null) {
		blur = 1.0;
	}
	if(alpha == null) {
		alpha = 1.0;
	}
	if(color == null) {
		color = 16776960;
	}
	(starling_filters_FragmentFilter().default).call(this);
	this._blurFilter = new (starling_filters_BlurFilter().default)(blur,blur);
	this._blurFilter.set_quality(quality);
	this._compositeFilter = new (starling_filters_CompositeFilter().default)();
	this._compositeFilter.setColorAt(0,color,true);
	this._compositeFilter.setAlphaAt(0,alpha);
	this.updatePadding();
}

// Meta

GlowFilter.__name__ = ["starling","filters","GlowFilter"];
GlowFilter.__super__ = (starling_filters_FragmentFilter().default);
GlowFilter.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	dispose: function() {
		this._blurFilter.dispose();
		this._compositeFilter.dispose();
		(starling_filters_FragmentFilter().default).prototype.dispose.call(this);
	},
	process: function(painter,helper,input0,input1,input2,input3) {
		var glow = this._blurFilter.process(painter,helper,input0);
		var result = this._compositeFilter.process(painter,helper,glow,input0);
		helper.putTexture(glow);
		return result;
	},
	get_numPasses: function() {
		return this._blurFilter.get_numPasses() + this._compositeFilter.get_numPasses();
	},
	updatePadding: function() {
		this.get_padding().copyFrom(this._blurFilter.get_padding());
	},
	get_color: function() {
		return this._compositeFilter.getColorAt(0);
	},
	set_color: function(value) {
		if(this.get_color() != value) {
			this._compositeFilter.setColorAt(0,value,true);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_alpha: function() {
		return this._compositeFilter.getAlphaAt(0);
	},
	set_alpha: function(value) {
		if(this.get_alpha() != value) {
			this._compositeFilter.setAlphaAt(0,value);
			this.setRequiresRedraw();
		}
		return value;
	},
	get_blur: function() {
		return this._blurFilter.get_blurX();
	},
	set_blur: function(value) {
		if(this.get_blur() != value) {
			this._blurFilter.set_blurX(this._blurFilter.set_blurY(value));
			this.setRequiresRedraw();
			this.updatePadding();
		}
		return value;
	},
	get_quality: function() {
		return this._blurFilter.get_quality();
	},
	set_quality: function(value) {
		if(this.get_quality() != value) {
			this._blurFilter.set_quality(value);
			this.setRequiresRedraw();
			this.updatePadding();
		}
		return value;
	}
});
GlowFilter.prototype.__class__ = GlowFilter.prototype.constructor = $hxClasses["starling.filters.GlowFilter"] = GlowFilter;

// Init

Object.defineProperties(GlowFilter.prototype,{ "color" : { get : function () { return this.get_color (); }, set : function (v) { return this.set_color (v); }}, "alpha" : { get : function () { return this.get_alpha (); }, set : function (v) { return this.set_alpha (v); }}, "blur" : { get : function () { return this.get_blur (); }, set : function (v) { return this.set_blur (v); }}, "quality" : { get : function () { return this.get_quality (); }, set : function (v) { return this.set_quality (v); }}});

// Statics




// Export

exports.default = GlowFilter;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/GlowFilter.js
// module id = 326
// module chunks = 0